import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import filter from 'lodash/filter';
import includes from 'lodash/includes';

import { getTerminalParamsByGatewayID } from '../utils';
import TerminalModal from '../TerminalModal';

const formatInitialValues = (terminalParameters, ccTerminal) => {
  const values = terminalParameters.reduce((parameters, currentParameter) => {
    if (currentParameter.id !== 'name') {
      parameters[currentParameter.id] = get(ccTerminal, `configuration.${currentParameter.id}`); // eslint-disable-line no-param-reassign
    }

    return parameters;
  }, {});

  values.name = get(ccTerminal, 'name');
  values.type = get(ccTerminal, 'type');

  return values;
};

const NON_EDITABLE_PARAMETERS = ['serialNumber', 'activationCode', 'terminalID'];
const filterNonEditableParameters = terminalParameters =>
  filter(
    terminalParameters,
    terminalParameter => !includes(NON_EDITABLE_PARAMETERS, terminalParameter.id)
  );

const EditTerminal = ({
  isOpen,
  onCancel,
  onSuccess,
  isProcessing,
  terminalParameters,
  gatewayConfig = {},
  ccTerminal,
  ccTerminalErrors,
}) => {
  const terminalGatewayID = gatewayConfig.gatewayID;
  const terminalParamsForSelectedGateway = filterNonEditableParameters(
    getTerminalParamsByGatewayID(terminalGatewayID, terminalParameters)
  );
  const initialValues = formatInitialValues(terminalParamsForSelectedGateway, ccTerminal);

  return (
    <TerminalModal
      isOpen={isOpen}
      onCancel={onCancel}
      onSuccess={onSuccess}
      isProcessing={isProcessing}
      terminalParameters={terminalParamsForSelectedGateway}
      initialValues={initialValues}
      terminalGatewayID={terminalGatewayID}
      ccTerminalErrors={ccTerminalErrors}
      edit
    />
  );
};

EditTerminal.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  isProcessing: PropTypes.bool,
  terminalParameters: PropTypes.arrayOf(PropTypes.shape(PropTypes.any.object)),
  gatewayConfig: PropTypes.shape(PropTypes.any.object),
  ccTerminal: PropTypes.shape(PropTypes.any.object),
  ccTerminalErrors: PropTypes.arrayOf(PropTypes.shape(PropTypes.any.object)),
};

export default EditTerminal;
